import React,{Component} from 'react';
import Carousel from '../Carousel/Carousel';
import CarouselIndicatior from '../Carousel/CarouselIndicatior';
import * as textActions from '../../actions/Texts';
import { connect } from 'react-redux';
import CarouselItem from '../Carousel/CarouselItem';
import textTranslates from './translate.json';
import Image1 from '../../img/img1.png';
import Image2 from '../../img/img2.jpg';
import Image3 from '../../img/img3.jpg';
import Image4 from '../../img/img4.jpg';
import Image5 from '../../img/img5.jpg';
import './StartPage.scss';

class StartPage extends Component {
   
    componentDidMount() {
        $('#items-carousel').carousel();
    }
   
    render() {
        const carouselId="items-carousel";
        return(
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="header-image-container">
                    <div className="header-image"></div>
                </div>
                <div className="container jumbotron col-xs-12 col-sm-12 col-md-8 col-md-offset-3 col-lg-6 text-container">
                
                    <h1 className="title-text">{textTranslates.header}</h1>
                    <h1 className="title-text-all">{textTranslates.headerAll}</h1>
                    <br />
                    {/* <h3 style={{color: "#0565AA", fontWeight: "bold"}}>{textTranslates.indiwidualClient}</h3>
                    <h3 style={{fontSize: "22px"}}>{textTranslates.createComplaintButton}<span style={{color: "#0565AA", fontWeight: "bold"}}>&quot;Utwórz zgłoszenie&quot;</span></h3>
                    <h3 style={{fontSize: "22px"}}>{textTranslates.complaintPreview}<span style={{color: "#0565AA", fontWeight: "bold"}}>&quot;Podgląd zgłoszenia&quot;</span></h3> */}
                    <h3 style={{color: "#0565AA", fontWeight: "bold",fontSize: "24px"}}>{textTranslates.biznesPartner}</h3>
                    <h3 style={{fontSize: "22px", fontWeight:"normal"}}>{textTranslates.b2bComplaint}<a href='https://elitameble.pl/b2b/' style={{fontWeight:"normal",fontSize:"24px" }} target="_blank" rel="noopener noreferrer"><br/><br/>{textTranslates.b2bLink}</a></h3>
                    <br/>
                    <h3 style={{color: "#0565AA", fontWeight: "bold",fontSize: "24px"}}>Jeśli nie kupiłeś naszych produktów bezpośrednio od nas</h3>
                    <h3 style={{fontSize: "22px", fontWeight:"normal"}}>- złóż reklamację klikając w powyższy przycisk <span style={{color: "#0565AA", fontWeight: "bold"}}>&quot;Utwórz zgłoszenie&quot;</span></h3>
                    <h3 style={{fontSize: "22px", fontWeight:"normal"}}>{textTranslates.complaintPreview}<span style={{color: "#0565AA", fontWeight: "bold"}}>&quot;Podgląd zgłoszenia&quot;</span></h3> 
                    <br/> 
                    <h3 className="questions-text">{textTranslates.questions}</h3>
                    <h3 className="phone-number">{textTranslates.phoneNumberText}</h3>
                    <h4 className="warranty-text">{textTranslates.helplineText}</h4>
                    <br/>
                    <br/>
                    <h3>{textTranslates.cheers}</h3>
                    {/* <h3 className="holiday-text">Szanowni Państwo, niniejszym informujemy, że: <br/>
                    <ul>
                        <li>W okresie 24.12.2018 r. - 04.01.2019 r  nastąpi przerwa w obsłudze reklamacji. </li>
                        <li>Reklamacje zarejestrowane w systemie do dnia 18.12.2018 r. będą jeszcze odbierane od klientów przed 22.12.2018 r. ale rozpatrywane po 03.01.2019 r. </li>
                        <li>Reklamacje zarejestrowane w systemie od dnia 19.12.2018 r. będą odbierane od klientów od 04.01.2019 r. </li>
                    </ul>
                    Przepraszamy za utrudnienia.</h3>
                    */}
                    <br />
                    <br />
                    <br />
                    {/* <h5 className="warranty-text">Szanowny Kliencie, 
                    zgodnie z obowiązującymi przepisami prawa każde roszczenie reklamacyjne może zostać zgłoszone w reżimie gwarancji lub rękojmi. 
                    Jeżeli zgłaszasz reklamację z udzielonej przez nas gwarancji, możesz skierować ją bezpośrednio do Elita Sp. z o. o., 
                    wykorzystując zamieszczony powyżej formularz - opcja dla klientów indywidualnych (podstawa prawna: art. 577 i nast. Kodeksu cywilnego). 
                    Jeżeli korzystasz z instytucji rękojmi, reklamację należy zgłosić bezpośrednio u sprzedawcy rzeczy, od którego ją zakupiłeś. 
                    Z tytuły rękojmi Elita Spółka z o. o przyjmuje zgłoszenia reklamacyjne w reżimie rękojmi w oparciu o zamieszczony powyżej formularz - 
                    opcja dla przedsiębiorców, tylko i wyłącznie gdy dokonałeś zakupu rzeczy bezpośrednio w naszej Spółce. 
                    Zatem mając na uwadze fakt, że Elita Sp. z o. o. nie prowadzi sprzedaży detalicznej, 
                    formularz ten przeznaczony jest dla naszych kooperantów (podstawa prawna: art. 556 Kodeksu cywilnego).
                    </h5>  */}
                    
                </div>
                {/* <div className="container hidden-xs hidden-sm col-md-4 col-lg-6">
                    <Carousel htmlId={carouselId}>
                        <ol className="carousel-indicators">
                            <CarouselIndicatior
                                active
                                carouselHtmlId={carouselId}
                                index="0" />
                            <CarouselIndicatior
                                carouselHtmlId={carouselId}
                                index="1" />
                            <CarouselIndicatior
                                carouselHtmlId={carouselId}
                                index="2" />
                            <CarouselIndicatior
                                carouselHtmlId={carouselId}
                                index="3" />
                            <CarouselIndicatior
                                carouselHtmlId={carouselId}
                                index="4" />
                        </ol>
                        <div
                            className="carousel-inner carousel"
                            role="listbox">
                            <CarouselItem className="carousel-img" active img={Image1} />
                            <CarouselItem className="carousel-img" img={Image2} />
                            <CarouselItem className="carousel-img" img={Image3}/>
                            <CarouselItem className="carousel-img" img={Image4}/>
                            <CarouselItem className="carousel-img" img={Image5}/>
                        </div>
                    </Carousel>
                </div> */}
            </div>);
    }
}

const mapStateToProps = (state) => {
    return {
        texts: state.texts.texts
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTexts: () => dispatch(textActions.getTexts())
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(StartPage);


// WEBPACK FOOTER //
// ./src/components/StartPage/StartPage.js